import React from "react";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";
import ParticlesAuth from "../../AuthenticationInner/ParticlesAuth";
import BotaoSuporte from "../../../Components/Common/BotaoSuporte";
import ChatScript from "../../../Layouts/ChatScript";

import { Link } from "react-router-dom";
import logoLight from "../../../assets/images/logo-light2.png";

// AIDEV-NOTE: Public customer registration suspended; displays support contact and login redirect
const CreatePassw = () => {
  document.title = "Criação de conta | Painel Fort Exchange";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="" height="70" />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={8} xl={6}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Nova Conta</h5>
                    </div>
                    <div className="p-2 mt-3">
                      <Alert color="warning" className="text-center mb-3">
                        <h6 className="alert-heading fw-bold mb-1">
                          Cadastro de novos clientes desativado
                        </h6>
                        <p className="mb-0">
                          O cadastro de novos clientes está temporariamente desativado. Em caso de dúvidas, entre em contato com nosso suporte.
                        </p>
                      </Alert>
                      <BotaoSuporte
                        className="btn btn-success w-100 mt-3"
                        texto="Falar com o suporte"
                        mensagem="Olá, gostaria de informações sobre o cadastro de novos clientes."
                      />
                      <Link to="/login" className="btn btn-light w-100 mt-2">
                        Voltar para o Login
                      </Link>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <ChatScript />
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default CreatePassw;
